import React from 'react'
import AppButton from "../../ui/AppButton";
import Alert from "@material-ui/lab/Alert";
import Modal from "@material-ui/core/Modal";
import Redirect from "../../helpers/Redirect";
import Session from "../../helpers/Session";
import Api from "../../helpers/Api";
import Env from "../../config/env";

class AlertDataTreatment extends React.Component {

    state = {
        url: '',
    };

    handleAgree = async (agree) => {

        if (!this.props.executeAPI) {
            const agreeTD = agree === 'S';
            this.props.updateAgreeTD(agreeTD);
            this.props.onCloseModal();
            return;
        }

        const userLogged = Session.getLogin();

        const params = {
            user: userLogged.terceroMail,
            type: 'TD',
            agree: agree,
            source: Env.ApplicationCode
        }
        const data = await Api.post(`${Env.UrlBackend}/privacy-policy/update`, params);
        if (data.success) {
            if (agree === 'S') {
                this.props.onCloseModal();
            } else {
                Session.logout();
                this.setState({
                    url: '/'
                });
            }
        }
    }

    render() {

        const {openModal, onCloseModal, disabledClose = true, showAgreeButton = true} = this.props;

        return (
            <div>
                <Redirect url={this.state.url}/>
                <Modal
                    open={openModal}
                    onClose={onCloseModal}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    disableBackdropClick={disabledClose}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Alert style={{textAlign: 'justify', width: '600px'}}
                           severity="info">

                        <div style={{height: '500px', overflowY: 'auto'}}>
                            <div style={{paddingRight: '20px'}}>
                                <h3 style={{textAlign: 'center'}}>POLITICA DE TRATAMIENTO DE DATOS</h3>

                                Acepto que mis datos sean tratados conforme a la política de tratamiento de
                                datos de Electrohuila S.A. - E.S.P. y la ley 1581 de 2.012 la cual incluye
                                el ofrecimiento de productos y servicios.
                            </div>
                        </div>

                        <table style={{width: '100%', textAlign: 'center'}}>
                            <tbody>
                            <tr>
                                <td>
                                    {
                                        showAgreeButton ?
                                            <span style={{padding: '5px'}}>
                                            <AppButton
                                                type='button'
                                                label='Si acepto'
                                                size='small'
                                                onClick={() => {
                                                    this.handleAgree('S')
                                                }}
                                            />
                                        </span> : null
                                    }

                                    <span style={{padding: '5px'}}>
                                    <AppButton
                                        type='button'
                                        label='No acepto'
                                        size='small'
                                        onClick={() => {
                                            this.handleAgree('N')
                                        }}
                                    />
                                </span>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </Alert>

                </Modal>
            </div>
        );
    }

}

export default AlertDataTreatment

